export default {
  title: 'Ajutor și întrebări frecvente',
  buttons: {
    faqs: 'ÎNTREBĂRI FRECVENTE',
    contact_us: 'Contactează-ne',
  },
};
